import axios from 'axios';
import { auth } from './auth.service';
import { ROOT_API_URL } from '../api-config';

export const userService = {
    getUserProfile
};

function getUserProfile(userName){
    var url = `${ROOT_API_URL}/users/profile`;
    const requestOptions = {
        method: 'POST',
        headers: auth.authHeader()
    };
    return axios.post(url, { email: userName }, requestOptions).then(response => response);
}